import { useSelector } from 'react-redux'
import { Pagination } from '../../../../common/pagination'
import { PAGE_SIZE_OPTIONS } from '../../constant'

const WrapPagination = ({ selectPaginationInfo, setPage, setPageSize }) => {
  const paginationInfo = useSelector(selectPaginationInfo)
  const { totalRecords, page, pageSize } = paginationInfo

  return (
    <div style={{ paddingTop: 12 }}>
      <Pagination
        page={page}
        pageSize={pageSize}
        total={totalRecords}
        setPage={setPage}
        setPageSize={setPageSize}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        zIndex={13}
      />
    </div>
  )
}

export default WrapPagination
